module.exports = __webpack_public_path__ + "static/media/alexa26.5afffb08.jpg";